import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/faq/faq-client.tsx");
